// @ts-strict-ignore
import React, { useCallback, useEffect, useState } from 'react'
import { useLocation } from 'APP/Hooks/useLocation'
import { isWeb } from 'APP/Helpers/checkPlatform'
import { Alert, Linking, View } from 'react-native'
import Dialog from 'APP/Converse/Dialog'
import i18n from 'APP/I18n'
import PlacePicker, { Place } from './PlacePicker'

const showMobileSettingsAlert = () => {
  Alert.alert('', i18n.t('SelfNavigationScreen.searchLocation.alertTitle'), [
    {
      text: i18n.t('SelfNavigationScreen.searchLocation.alertButton'),
      onPress: () => {
        Linking.openSettings()
      },
    },
  ])
}

export interface SearchLocationProps {
  place: Place | 'current' | null
  onValueChange: (value: Place | 'current' | null) => void
}

const SearchLocation = ({ place, onValueChange }: SearchLocationProps) => {
  const [showNoPermissionDialog, setShowNoPermissionDialog] = useState<boolean>(false)
  const { error, hasLocation, hasNoLocationPermission, requestLocationPermission } = useLocation({
    requestOnFocus: false,
  })

  const handleNoLocationPermission = useCallback(() => {
    if (isWeb()) {
      setShowNoPermissionDialog(true)
      return
    }

    showMobileSettingsAlert()
  }, [])

  const handlePlaceChange = useCallback(
    (option: 'current' | Place | null) => {
      if (!hasLocation && option === 'current') {
        requestLocationPermission()
        onValueChange(null)
        return
      }

      onValueChange(option)
    },
    [hasLocation, requestLocationPermission, onValueChange]
  )

  useEffect(() => {
    if (hasNoLocationPermission) {
      handleNoLocationPermission()
    }
  }, [hasNoLocationPermission, handleNoLocationPermission])

  return (
    <View testID="SEARCH_LOCATION_CONTAINER">
      <Dialog
        isVisible={showNoPermissionDialog}
        onClose={() => setShowNoPermissionDialog(false)}
        title={i18n.t('SelfNavigationScreen.searchLocation.locationAccessNeeded')}
        subtitle={i18n.t('SelfNavigationScreen.searchLocation.dialogSubtitle')}
        testId="LOCATION_PERMISSION_DIALOG"
      />
      <PlacePicker
        value={place}
        onChange={handlePlaceChange}
        hasCurrentLocation={hasLocation}
        error={place == null ? error : undefined}
      />
    </View>
  )
}

export default SearchLocation
